import React, {useState } from 'react';
import MesCards from '../../utils/MesCards'
import Artistess from '../Pages/Artistes/Artistes'
import NavArtistBlack from '../NavArtistBlack/NavArtistBlack'
import BGArtiste from '../../assets/BGArtiste.jpg'

const ArtistesPage = () => {

    const [data, setData] = useState(MesCards)

    let newArray = [];

    const FunctionModify = (e) => {
       
        let eTargetValue = e.target.value
        if(eTargetValue === "Tous")
            setData(MesCards)
        else{
            newArray = MesCards.filter((item) => {
                return item.NameArtist[0] === eTargetValue})
                
            setData(newArray)
        }
    }
    

        return(
        <div>

            <div className="img-fluid" style={{backgroundImage: `url(${BGArtiste})`, height: 400+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0, backgroundSize: 'cover'}}>
                <h1 className="text-center text-white pt-5">Nos artistes</h1>
            </div>

            <NavArtistBlack onClick={FunctionModify} />
            
            <div className="mb-5">
                <Artistess newArray={data} />
            </div>
        </div>
        )
}


export default ArtistesPage


